import { createSlice } from '@reduxjs/toolkit';

import { getPrevNextIds } from '../../helpers/common';

import {
  createGeofence,
  deleteGeofence,
  deleteGeofences,
  fetchGeofence,
  fetchGeofences,
  updateGeofence
} from '../actions/geofence';

const geofenceSlice = createSlice({
  name: 'geofence',
  initialState: {
    data: [],
    error: null,
    filterOptions: [],
    geofence: null,
    loading: false,
    pastures: [],
    selectOptions: [],
    sortedData: []
  },
  reducers: {
    setSortedData: (state, action) => {
      state.sortedData = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      // Create Geofence
      .addCase(createGeofence.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createGeofence.fulfilled, (state, action) => {
        state.loading = false;
        state.geofence = action.payload;
      })
      .addCase(createGeofence.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Geofences
      .addCase(fetchGeofences.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGeofences.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.filterOptions = action.payload.filterOptions;
        state.selectOptions = action.payload.selectOptions;
        state.pastures = action.payload.pastures;
        state.loading = false;
      })
      .addCase(fetchGeofences.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Geofence
      .addCase(fetchGeofence.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGeofence.fulfilled, (state, action) => {
        state.loading = false;
        const { prev_id, next_id } = state.sortedData?.length
          ? getPrevNextIds(state.sortedData, action.payload?.id)
          : { prev_id: action.payload.prev_id, next_id: action.payload.next_id };
        state.geofence = { ...action.payload, prev_id, next_id };
      })
      .addCase(fetchGeofence.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Geofence
      .addCase(updateGeofence.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGeofence.fulfilled, (state, action) => {
        state.loading = false;
        state.geofence = action.payload;
      })
      .addCase(updateGeofence.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Geofences
      .addCase(deleteGeofences.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteGeofences.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(record => !action.payload?.includes(record.id));
      })
      .addCase(deleteGeofences.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Geofence
      .addCase(deleteGeofence.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteGeofence.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteGeofence.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSortedData } = geofenceSlice.actions;
export default geofenceSlice.reducer;
